import React from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-medium transition-all duration-300 transform active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-teal-700 text-white hover:bg-teal-800 shadow-lg hover:shadow-xl focus:ring-teal-500',
    secondary: 'bg-white text-teal-900 hover:bg-teal-50 shadow-md hover:shadow-lg focus:ring-teal-200',
    outline: 'border-2 border-teal-700 text-teal-800 hover:bg-teal-50 focus:ring-teal-500'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-1">
      {children}
    </button>;
}